import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import useFormSubmission from 'flow-doctor-lib/hooks/useFormSubmission';
import useContentPage from 'flow-doctor-lib/hooks/useContentPage';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { formatTimestampToPortalTz } from 'flow-doctor-lib/utils/dateTimeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WalmartFormSubmissionFilterEvaluationDataRow = ({
  formSubmissionData
}) => {
  const {
    data: formData,
    loading: formLoading,
    error: formError
  } = useFormSubmission({
    portalId: PortalIdParser.get(),
    formId: formSubmissionData.formId
  });
  const {
    data: pageData,
    loading: pageLoading,
    error: pageError
  } = useContentPage({
    portalId: PortalIdParser.get(),
    pageId: formSubmissionData.pageId
  }, {
    skip: !formSubmissionData.pageId
  });
  const showLoadingFormName = !formError && (formLoading || !formData);
  const showLoadingPageName = !!formSubmissionData.pageId && !pageError && (pageLoading || !pageData);
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      children: showLoadingFormName ? /*#__PURE__*/_jsx(SkeletonText, {
        width: 200
      }) : /*#__PURE__*/_jsx(UITruncateString, {
        children: formData ? formData.name : formSubmissionData.formId
      })
    }), /*#__PURE__*/_jsx("td", {
      children: showLoadingPageName ? /*#__PURE__*/_jsx(SkeletonText, {
        width: 200
      }) : /*#__PURE__*/_jsx(UITruncateString, {
        children: pageData ? pageData.label : formSubmissionData.pageId
      })
    }), /*#__PURE__*/_jsx("td", {
      children: formatTimestampToPortalTz(formSubmissionData.timestamp)
    })]
  });
};
export default WalmartFormSubmissionFilterEvaluationDataRow;